import { render } from "./BigRadialBackground.vue?vue&type=template&id=514bec73&scoped=true"
import script from "./BigRadialBackground.vue?vue&type=script&lang=js"
export * from "./BigRadialBackground.vue?vue&type=script&lang=js"

import "./BigRadialBackground.vue?vue&type=style&index=0&id=514bec73&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-514bec73"]])

export default __exports__